CustomScriptService.$inject = ["coreApi"];
import "core-js/modules/es6.array.map.js";
import { OpportunitiesModule } from '../core/opportunities.module';
OpportunitiesModule.factory('customScriptService', CustomScriptService);

/* @ngInject */
function CustomScriptService(coreApi) {
  var service = {
    getCustomScriptsByDealerId: getCustomScriptsByDealerId,
    saveCustomScript: saveCustomScript
  };
  return service;
  function getCustomScriptsByDealerId(dealerId) {
    assert(dealerId, 'dealerId must be provided');
    return coreApi.api.CustomScript.GetCustomScriptsByDealerId.GET({
      dealerId: dealerId
    }).then(function (response) {
      return (response.data || []).map(mapCustomScript);
    });
  }
  function saveCustomScript(customScript) {
    assert(customScript, 'customScript must be provided');
    return coreApi.api.CustomScript.SaveCustomScript.POST(customScript).then(function (response) {
      return response.status === 204;
    });
  }
  function mapCustomScript(script) {
    var _ref, _script$id, _script$dealerID, _script$scriptTypeID, _ref2, _ref3, _script$createdByFull;
    return {
      id: (_ref = (_script$id = script.id) !== null && _script$id !== void 0 ? _script$id : script.customScriptID) !== null && _ref !== void 0 ? _ref : script.customScriptId,
      dealerID: (_script$dealerID = script.dealerID) !== null && _script$dealerID !== void 0 ? _script$dealerID : script.dealerId,
      scriptTypeID: (_script$scriptTypeID = script.scriptTypeID) !== null && _script$scriptTypeID !== void 0 ? _script$scriptTypeID : script.scriptTypeId,
      culture: script.culture,
      version: script.version,
      createDate: script.createDate,
      createdBy: script.createdBy,
      createdByFullName: (_ref2 = (_ref3 = (_script$createdByFull = script.createdByFullName) !== null && _script$createdByFull !== void 0 ? _script$createdByFull : script.createdByName) !== null && _ref3 !== void 0 ? _ref3 : script.createdByUserName) !== null && _ref2 !== void 0 ? _ref2 : script.createdBy,
      scriptBody: script.scriptBody
    };
  }
  function assert(condition, message) {
    if (!condition) {
      throw new Error(message);
    }
  }
}